import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AdminServices } from "../../../../../services/admin/AdminServices";
import { validateEmail } from "../../../../../utils/validation";
import { RootState } from "../../store";

interface UserInfoProps {
  userIdOrEmail: string;
}

interface Address {
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  locality: string;
  lat: string;
  lng: string;
}

interface Store {
  storeId: string;
  storeName: string;
  role: string;
}

interface OrgInfo {
  organizationName: string;
  stores: Store[];
}

interface UserResponse {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  type: string;
  status: string;
  phoneNumber: string;
  gender: string;
  userCategory: string;
  address: Address;
  accessInfo: Record<string, OrgInfo>;
  category?: string;
  subCategory?: string;
  currentOrganizationId?: string;
  currentStoreId?: string;
}


const UserInfo: React.FC<UserInfoProps> = ({ userIdOrEmail }) => {
  const [showAddress, setShowAddress] = useState(false);
  const [expandedOrgs, setExpandedOrgs] = useState<Record<string, boolean>>({});

  const userData = useSelector(
  (state: RootState) => state.user.searchedUserDetails as UserResponse | null
);

useEffect(()=>{
  console.log("wedsfdxwasdx",userData)
},[userData])



  const toggleOrg = (orgId: string) => {
    setExpandedOrgs((prev) => ({ ...prev, [orgId]: !prev[orgId] }));
  };

  const displayValue = (value: string | number | null | undefined) =>
    value && String(value).trim() !== "" ? value : "-";

  if (!userData) {
    return <div className="text-gray-500 h-[10vh] text-semibold text-xl flex justify-center items-center">Loading User Info...</div>;
  }

  return (
    <div className="border rounded-lg shadow-md p-6 w-full max-w-3xl mx-auto bg-white">
      <h2 className="text-lg font-bold mb-4">User Information</h2>
      <table className="w-full border-collapse text-sm">
        <tbody>
          <tr className="border-b">
            <td className="font-semibold p-2 w-1/3">Name</td>
            <td className="p-2">
              {displayValue(`${userData.firstName || ""} ${userData.lastName || ""}`.trim())}
            </td>
          </tr>
          <tr className="border-b">
            <td className="font-semibold p-2">Email</td>
            <td className="p-2">{displayValue(userData.email)}</td>
          </tr>
          <tr className="border-b">
            <td className="font-semibold p-2">Phone</td>
            <td className="p-2">{displayValue(userData.phoneNumber)}</td>
          </tr>
          <tr className="border-b">
            <td className="font-semibold p-2">Gender</td>
            <td className="p-2">{displayValue(userData.gender)}</td>
          </tr>
          <tr className="border-b">
            <td className="font-semibold p-2">Type</td>
            <td className="p-2">{displayValue(userData.type)}</td>
          </tr>
          <tr className="border-b">
            <td className="font-semibold p-2">User Category</td>
            <td className="p-2">{displayValue(userData.userCategory)}</td>
          </tr>
          <tr className="border-b">
            <td className="font-semibold p-2">Status</td>
            <td className="p-2">{displayValue(userData.status)}</td>
          </tr>

          {/* Collapsible Address */}
          <tr
            className="cursor-pointer hover:bg-gray-50"
            onClick={() => setShowAddress((prev) => !prev)}
          >
            <td className="font-semibold p-2">Address</td>
            <td className="p-2 text-blue-600">
              {showAddress ? "Hide details ▲" : "Show details ▼"}
            </td>
          </tr>
          {showAddress && userData.address && (
            <tr>
              <td colSpan={2} className="p-2 bg-gray-50">
                <table className="w-full text-sm border border-gray-200 rounded-md">
                  <tbody>
                    {Object.entries(userData.address).map(([key, value]) => (
                      <tr key={key}>
                        <td className="font-semibold p-2 capitalize">{key}</td>
                        <td className="p-2">{displayValue(value)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td>
            </tr>
          )}

          {/* Organizations */}
          {userData.accessInfo &&
            Object.entries(userData.accessInfo).map(([orgId, org]) => (
              <React.Fragment key={orgId}>
                <tr
                  className="cursor-pointer hover:bg-gray-50 border-b"
                  onClick={() => toggleOrg(orgId)}
                >
                  <td className="font-semibold p-2">Organization</td>
                  <td className="p-2 text-blue-600">
                    {displayValue(org.organizationName)}{" "}
                    {expandedOrgs[orgId] ? "▲" : "▼"}
                  </td>
                </tr>
                {expandedOrgs[orgId] && (
                  <tr>
                    <td colSpan={2} className="p-2 bg-gray-50">
                      <table className="w-full text-sm border border-gray-200 rounded-md">
                        <tbody>
                          {org.stores.map((store) => (
                            <tr key={store.storeId}>
                              <td className="font-semibold p-2">Store Name</td>
                              <td className="p-2">
                                {displayValue(store.storeName)} ({displayValue(store.role)})
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserInfo;
